import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { initializeWebMCP } from './utils/webmcp';

// Initialize WebMCP (Web Model Context Protocol) for autonomous AI agents
initializeWebMCP();

createRoot(document.getElementById('root')!).render(<App />);
